import { useEffect, useState } from "react";
import { Formik, getIn } from "formik";
import { Button, Card, Col, Row, Spinner } from "reactstrap";
import QueryString from "qs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import FormInput from "../../../components/FormInput";
import { validationSchema } from "../../../validations/employee.validation";
import {
  addEmployee,
  getEmployee,
  updateEmployee,
} from "../../../services/employees.service";

interface InitialValues {
  name: string;
}

const initialValues: InitialValues = {
  name: "",
};

export default function Form() {
  const location = useLocation();
  const navigate = useNavigate();
  const params: any = useParams();
  const [initialValuesData, setInitialValuesData] = useState(initialValues);
  const [loader, setLoader] = useState(true);
  const query: any = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (params.id) {
      getEmployee(params.id)
        .then((response) => {
          setInitialValuesData({
            ...initialValues,
            name: response.data.name || "",
          });
          setLoader(false);
        })
        .catch((error) => {
          toast.error(`Error fetching employee data: ${JSON.stringify(error)}`);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, [params.id]);

  const redirectPath = query.redirect || "/employees";

  function handleSubmit(values: InitialValues, actions: any) {
    const request = params.id ? updateEmployee(params.id, values) : addEmployee(values);

    request
      .then((response) => {
        toast.success(response?.data?.message || `Employee ${params.id ? "updated" : "added"} successfully`);
        navigate(redirectPath);
      })
      .catch(() => {
        toast.error(`Failed to ${params.id ? "update" : "add"} employee`);
        actions.setSubmitting(false);
      });
  }

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      {loader ? (
        <Spinner />
      ) : (
        <Formik
          initialValues={initialValuesData}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <>
              <Row className='align-items-center mb-2 page-title-row'>
                <Col sm>
                  <h1 className='my-1 fw-bold h4'>Employee Master</h1>
                </Col>
                <Col sm='auto'>
                  <div className='justify-content-between'>
                    <Button
                      size='sm'
                      color='secondary'
                      className='my-1 me-2 fw-semibold'
                      style={{ opacity: 1 }}
                      onClick={() => {
                        navigate(redirectPath);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size='sm'
                      color='primary'
                      className='my-1 text-white'
                      onClick={() => handleSubmit()}
                    >
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className='flex-grow-1 overflow-auto'>
                <Card className='h-100 p-3 w-100'>
                  <Col md={8}>
                    <div className='d-flex flex-column h-100 rounded-0'>
                      <form onSubmit={handleSubmit}>
                        <Row>
                          <Col md={6}>
                            <FormInput
                              name='name'
                              label='Employee Name'
                              placeholder='Employee Name'
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={getIn(values, "name")}
                              error={getIn(errors, "name")}
                              touched={getIn(touched, "name")}
                            />
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </Col>
                </Card>
              </div>
            </>
          )}
        </Formik>
      )}
    </div>
  );
}
